import DatarowsViewer from "./components/DatarowsViewer.vue";

const DatarowsViewerPlugin = {
	install(Vue, options) {
		Vue.component(DatarowsViewer.name, DatarowsViewer);
	},
};

// Automatic installation if Vue has been added to the global scope.
if (typeof window !== "undefined" && window.Vue)
	window.Vue.use(DatarowsViewerPlugin);

export default DatarowsViewerPlugin;
export { DatarowsViewer };
